import {
  mdiCreation,
  mdiImage,
  mdiImageMultiple,
  mdiImageOff,
  mdiImageSearch,
  mdiLinkVariant,
} from "@mdi/js";

// Libelles des modes image AIF (report-api app/services/aif_image.py).
// Couleurs en hexa : le color-pack Vuetify est desactive ($color-pack: false), seules
// les couleurs du theme (primary, info...) existent en nom.
export const AIF_IMAGE_MODES = {
  generate: {
    label: "Générer",
    color: "primary",
    icon: mdiImage,
    hint: "Générer l'image (modèle et format définis par le prompt image du site)",
  },
  shutterstock_search: {
    label: "Shutterstock",
    color: "#E64A19",
    icon: mdiImageSearch,
    hint: "Photo de la banque Shutterstock (choisie automatiquement d'après l'article, puis licenciée)",
  },
  shutterstock_generate: {
    label: "Shutterstock IA",
    color: "#7B1FA2",
    icon: mdiCreation,
    hint: "Image générée par l'IA Shutterstock (même prompt que « Générer »), puis licenciée",
  },
  image_url: {
    label: "URL fournie",
    color: "#00897B",
    icon: mdiLinkVariant,
    hint: "Image fournie par URL",
  },
  image_id: {
    label: "Média existant",
    color: "#00897B",
    icon: mdiImageMultiple,
    hint: "Média déjà présent dans le CMS",
  },
  none: {
    label: "Aucune",
    color: "#757575",
    icon: mdiImageOff,
    hint: "Publier sans image",
  },
};

// Reserves aux superadmins (all/manage) : licences payantes et quota de
// generation IA commun. Le back refuse ces modes aux autres (403).
export const AIF_SUPERADMIN_IMAGE_MODES = [
  "shutterstock_search",
  "shutterstock_generate",
];

// Modes proposes a l'utilisateur dans les process manuels.
export const AIF_SELECTABLE_IMAGE_MODES = [
  "none",
  "generate",
  "shutterstock_search",
  "shutterstock_generate",
];

const ALIASES = { skip: "none", no_image: "none" };

// Comme ImageHandler.from_raw : toute valeur inconnue (vide, "default_config",
// ancien nom de modele) vaut "generate".
export const aifImageModeFor = (handler) => {
  const value = String(handler || "")
    .trim()
    .toLowerCase();
  return AIF_IMAGE_MODES[ALIASES[value] || value] || AIF_IMAGE_MODES.generate;
};
